module.exports = __webpack_public_path__ + "img/72_16.7bcab80f.png";